module.exports = __webpack_public_path__ + "static/media/obxLogo.2949c576.png";